import React from "react";
import { Panel, Header, Logo, Facets, ToggleButton, ToggleButtonLabel } from "./styled";

function DistrictDetail({ className, isOpen, onToggle, district, mea }) {
  const togglePanel = () => {
    onToggle();
  };

  const awards = mea.filter((award) => {
    return award["School District"] === district?.name;
  });

  const sort = (arr) => {
    return arr.sort((a, b) => {
      // Convert both values to strings and compare
      return a.localeCompare(b, undefined, { numeric: true });
    });
  };

  const awardYears = sort([
    ...new Set(awards.map((award) => award["Fiscal Year(s)"]).filter((val) => val !== "")),
  ]);
  const decarbonizingTechnology = sort([
    ...new Set(awards.map((award) => award["Decarbonizing PROJECT"]).filter((val) => val !== "")),
  ]);
  const aoiCategories = sort([...new Set(awards.map((award) => award["AOI"]).filter((val) => val !== ""))]);
  const projectDescriptions = sort([
    ...new Set(
      awards.map(
        (award) => `${award["AOI"].split(":")[0]}: ${award["Project Description"]}`
      ).filter((val) => val !== "")
    ),
  ]);

  const image = awards.length && awards[0]["Header Image"] ? awards[0]["Header Image"] : null;

  return (
    <Panel className={className} isOpen={isOpen} position="left">
      <ToggleButton onClick={togglePanel} isOpen={isOpen} position="left">
        <ToggleButtonLabel>District</ToggleButtonLabel>
      </ToggleButton>
      <Header default={!image}>
      {district && <Logo default={!image} src={`/logos/${image || 'default.jpg'}`} alt="" />}
      </Header>
      <Facets>
      <h2>{district?.name}</h2>
      {aoiCategories.length > 0 && (
        <>
          <h3>Area of Interest (AOI) Category</h3>
          <ul>
            {aoiCategories.map((aoiCategories) => (
              <li>{aoiCategories}</li>
            ))}
          </ul>
        </>
      )}{" "}
      {decarbonizingTechnology.length > 0 && (
        <>
          <h3>Decarbonizing Projects</h3>
          <ul>
            {decarbonizingTechnology.map((decarbonizingTechnology) => (
              <li>{decarbonizingTechnology}</li>
            ))}
          </ul>
        </>
      )}
      {awardYears.length > 0 && (
        <>
          <h3>Fiscal Year(s)</h3>
          <ul>
            {awardYears.map((awardYear) => (
              <li>{awardYear}</li>
            ))}
          </ul>
        </>
      )}{" "}
      {projectDescriptions.length > 0 && (
        <>
          <h3>Project Description</h3>
          <ul>
            {projectDescriptions.map((description) => (
              <li>{description}</li>
            ))}
          </ul>
        </>
      )}</Facets>
    </Panel>
  );
}

export default DistrictDetail;
